export default __webpack_public_path__ + "static/media/services-application-mobile.93cbbaad.svg";